import { ReactComponent as SPORTS_IMG } from "../../assets/images/Frame (10).svg";
import { ReactComponent as SLOTS } from "../../assets/images/Slots.svg";
import { ReactComponent as ROULETTE_IMG } from "../../assets/images/Roulette.svg";
import { ReactComponent as MESSAGE_IMG } from "../../assets/images/message.svg";
import { ReactComponent as CHECKMARK_IMG } from "../../assets/images/checkmark.svg";
import { ReactComponent as SUPPORT_IMG } from "../../assets/images/headphones-icon.svg";
import { ReactComponent as EVENT_IMG } from "../../assets/images/star-icon.svg";
import { ReactComponent as NOTICE_IMG } from "../../assets/images/statistics-icon.svg";
import { ReactComponent as BETTING_HISTORY_IMG } from "../../assets/images/MyBets.svg";
import {
  CasinoCardIcon as CASINO_IMG,
  TelegramPaperPlaneIcon as TELEGRAM_IMG,
} from "../../components/Common/Icons/GameCategoryIcons";

import { ReactComponent as USER } from "../../assets/modelImages/Frame (6).svg";
import { ReactComponent as BUILD } from "../../assets/modelImages/Frame (9).svg";

export const SECTIONS = [
  {
    name: "게임",
    selectedOption: null,
    options: [
      {
        icon: CASINO_IMG,
        text: "카지노",
        hasDropdown: true,
        selectedSubOption: null,
        isOpenedDropdown: false,
        sidebarUrl: "/live-casino",
        dropdownSource: "live-casino",
        dropdownOptions: [],
      },
      {
        icon: SLOTS,
        text: "슬롯",
        hasDropdown: true,
        selectedSubOption: null,
        isOpenedDropdown: false,
        sidebarUrl: "/slots",
        dropdownSource: "slots",
        dropdownOptions: [],
      },
      {
        icon: SPORTS_IMG,
        text: "스포츠",
        hasDropdown: true,
        selectedSubOption: null,
        isOpenedDropdown: false,
        sidebarUrl: "/sports?type=DOMESTIC",
        dropdownOptions: [
          { icon: SPORTS_IMG, text: "국내형", sidebarUrl: "/sports?type=DOMESTIC" },
          { icon: SPORTS_IMG, text: "해외형", sidebarUrl: "/sports?type=INTERNATIONAL" },
          {
            icon: SPORTS_IMG,
            text: "라이브",
            sidebarUrl: "/sports?type=LIVE&sport_id=1&page=1&live_page=1",
          },
          { icon: SPORTS_IMG, text: "E스포츠", sidebarUrl: "/sports?type=SPECIAL" },
        ],
      },
      {
        icon: SPORTS_IMG,
        text: "BTI스포츠",
        sidebarUrl: "#",
        launchVendor: "bti",
      },
      {
        icon: SPORTS_IMG,
        text: "SABA스포츠",
        sidebarUrl: "#",
        launchVendor: "saba",
      },
    ],
  },
  {
    name: "마이메뉴",
    selectedOption: null,
    options: [
      {
        icon: USER,
        text: "프로필",
        sidebarUrl: "/account/profile",
      },
      {
        icon: BETTING_HISTORY_IMG,
        text: "베팅내역",
        sidebarUrl: "/betting-history",
      },
      {
        icon: BUILD,
        text: "입금",
        sidebarUrl: "/account/deposits/ALL",
      },
      {
        icon: BUILD,
        text: "출금",
        sidebarUrl: "/account/withdrawals/ALL",
      },
    ],
  },
  {
    name: "이벤트/공지",
    selectedOption: null,
    options: [
      { icon: EVENT_IMG, text: "이벤트", sidebarUrl: "/event" },
      { icon: NOTICE_IMG, text: "공지사항", sidebarUrl: "/event?tab=anouncement" },
    ],
  },
  {
    name: "고객지원",
    selectedOption: null,
    options: [
      { icon: SUPPORT_IMG, text: "고객문의", sidebarUrl: "/customer-service-center" },
      { icon: MESSAGE_IMG, text: "쪽지", sidebarUrl: "/notice-board" },
      {
        icon: TELEGRAM_IMG,
        text: "텔레그램 문의",
        sidebarUrl: "#telegram-contact",
        externalType: "telegram",
      },
    ],
  },
  {
    name: "리워드",
    selectedOption: null,
    options: [
      { icon: CHECKMARK_IMG, text: "출석체크", sidebarUrl: "/attendance-check" },
      { icon: ROULETTE_IMG, text: "룰렛", sidebarUrl: "/roulette" },
    ],
  },
];

export const ACCOUNT_DROPDOWN_OPTIONS = [
  {
    label: "프로필",
    route: "/account/profile",
    icon: USER,
    altText: "user",
  },
  {
    label: "고객문의",
    route: "/customer-service-center",
    icon: SUPPORT_IMG,
    altText: "support",
  },
  {
    label: "쪽지",
    route: "/notice-board",
    icon: MESSAGE_IMG,
    altText: "message",
  },
];

export const BUTTONS_MY_BETS = [
  { label: "전체", url: "#" },
  { label: "진행중", url: "#" },
  { label: "당첨", url: "#" },
  { label: "미당첨", url: "#" },
  { label: "캐시아웃", url: "#" },
  { label: "취소", url: "#" },
  { label: "환불", url: "#" },
];
